<template>

    <div class="blog-content parallax">

        <nav class="navbar navbar-expand-lg navigation-mobile">
            <div class="collapse navbar-collapse">
                <ul class="navbar-nav">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
                            How we share the information that
                            we collect
                        </a>
                        <img src="/img/dropdown_arrow.svg" class="arrow">
                        <div class="dropdown-menu">
                            <a href="#link1" class="dropdown-item nav-link-1 active">Interpretation and Definitions</a>
                            <a href="#link2" class="dropdown-item nav-link-2">Collecting and Using Your Personal
                                Data</a>
                            <a href="#link3" class="dropdown-item nav-link-3">Detailed Information on the Processing of
                                Your Personal Data</a>
<!--                            <a href="#link4" class="dropdown-item nav-link-4">Links to Other Websites</a>-->
<!--                           <a href="#link5" class="dropdown-item nav-link-5">Changes to this Privacy Policy</a>-->
<!--                            <a href="#link6" class="dropdown-item nav-link-6">Contact us</a>-->
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="navigation">
            <ul>
                <li><a href="#link1" class="nav-link-1 active">general information</a></li>
                <li><a href="#link2" class="nav-link-2 ">How we use your information</a></li>
                <li><a href="#link3" class="nav-link-3">How we share the information that we collect</a></li>
<!--                <li><a href="#link3" class="nav-link-3">How long we retain your information</a>-->
<!--                </li>-->
<!--                <li><a href="#link4" class="nav-link-4">Your rights</a></li>-->
<!--                <li><a href="#link5" class="nav-link-5">Changes to this policy</a></li>-->
<!--                <li><a href="#link6" class="nav-link-6">Contact us</a></li>-->
            </ul>
            <div class="social">
                <ShareNetwork
                    network="telegram"
                    :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                    <img src="/img/share_telegram.svg">
                </ShareNetwork>
                <ShareNetwork
                    network="facebook"
                    :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                    <img src="/img/share_fb.svg">
                </ShareNetwork>
                <ShareNetwork
                    network="linkedIn"
                    :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                    <img src="/img/share_linkdin.svg">
                </ShareNetwork>
                <ShareNetwork
                    network="twitter"
                    :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                    <img src="/img/share_twitter.svg">
                </ShareNetwork>
                <a href="#" @click.stop.prevent="copyUrl">
                <img src="/img/share_link.svg"></a>

            </div>
        </div>
        <div class="blog">
            <h1>Our market research for hypercasual games</h1>
            <span>March 8, 2021</span>
            <img src="/img/facebook_pavel.png" class="conference-img">
            <span class="conference-description">A super caption that will add a description to the picture can be in three lines.
A super caption that will add a description to the picture can be in three lines.
            </span>

            <h2 id="link1">General information</h2>
            <h3>1. Information collected automatically</h3>
            <p>When you visit the Site, we and certain third-party services (“Service Provider”) such as Google
                Analytics, may automatically collect certain information about you when you access or use the Site
                (“Usage Information”). Usage Information may include but is not limited to your IP address; device
                identifier; browser type; operating system; information about your use of and interaction with the Site;
                and data regarding network connected hardware (e.g., computer or mobile device).
                The methods that may be used on the Site to collect Usage Information include:</p>
            <ul>
                <li><p><span>“Log files”</span>, which tracks your interactions with the Site.</p></li>
                <li><p><span>“Cookies”</span> are small text files that are stored on a user’s device which may be
                    session ID cookies or tracking cookies. Session cookies make it easier for you to navigate the
                    Site and expire when you close your browser. Tracking cookies remain longer and help in
                    understanding how you use the Site, and enhance your user experience. For more information about
                    cookies, and how to disable cookies, visit <a
                        href="https://www.storeglide.com">https://www.allaboutcookies.org</a>. Except as otherwise
                    used by our third-party Service Providers, we do not store your information in cookies.</p>
                </li>
                <li><p><span>“Web beacons” </span> are small graphic images, also known as “Internet tags” or “clear
                    gifs,” embedded in web pages and email messages. Web beacons may be used, without limitation, to
                    count the number of visitors to the Site, to monitor how users navigate the Site, and to count
                    content views.</p></li>
            </ul>
            <h3 id="link2">2. Information you voluntarily supplied</h3>
            <p>We may collect your personally identifiable information you voluntarily supplied to us. For example, we
                may ask for your full name and email address when you send us a message using the contact form on the
                Site.</p>

            <div class="quote">
                <img src="/img/quote.svg" class="quote-img">
                <p>When you visit the Site, we and certain third-party services (“Service Provider”) such as Google
                    Analytics, may automatically collect certain information about you when you access or use the Site
                    (“Usage Information”). Usage Information may include but is not limited to your IP address d to your
                    IP address d to your IP address.</p>
                <div class="author">
                    <img src="/img/pavel.png">
                    <p class="name">Pavel Karabanov</p>
                    <span>Head of hypercasual in HighCore</span>
                </div>
            </div>
            <h2 id="link3">Numbered list</h2>
            <h3>Information collected automatically</h3>
            <p>When you visit the Site, we and certain third-party services (“Service Provider”) such as network
                connected hardware (e.g., computer or mobile device).
            </p>
            <p>The methods that may be used on the Site to collect Usage Information include:</p>
            <ul class="numeric">
                <li><span class="number">1</span><p><span>“Log files”</span>, which tracks your interactions with the Site.</p></li>
                <li><span class="number">2</span><p><span>“Cookies”</span> are small text files that are stored on a user’s device which may be.</p>
                </li>
                <li><span class="number">3</span><p><span>“Web beacons” </span> are small graphic images, also known as “Internet tags” or “clea.</p>
                </li>
            </ul>

        </div>
        <div class="social mobile">
            <ShareNetwork
                network="telegram"
                :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                <img src="/img/share_telegram.svg">
            </ShareNetwork>
            <ShareNetwork
                network="facebook"
                :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                <img src="/img/share_fb.svg">
            </ShareNetwork>
            <ShareNetwork
                network="linkedIn"
                :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                <img src="/img/share_linkdin.svg">
            </ShareNetwork>
            <ShareNetwork
                network="twitter"
                :url="blogUrl" :title="shareTitle" :description="shareDescription" :quote="shareQuote" hashtags="storeglide">
                <img src="/img/share_twitter.svg">
            </ShareNetwork>
            <a href="#" @click.stop.prevent="copyUrl">
                <img src="/img/share_link.svg"></a>
        </div>
    </div>

</template>

<script>

export default {

    methods: {
        copyUrl() {
            let container = this.$refs.container
            this.$copyText(this.blogUrl, container);
            alert('Copied!');

        }
    },
    data() {
        return {
            blogUrl: 'https://dev.storeglide.com/blog',
            shareTitle: 'Storeglide Blog',
            shareDescription: 'Our market research for hypercasual games',
            shareQuote: 'When you visit the Site, we and certain third-party services (“Service Provider”) such as Google Analytics, may automatically collect certain information about you when you access or use the Site (“Usage Information”). Usage Information may include but is not limited to your IP address d to your IP address d to your IP address.'
        };

    },
}

</script>
